export const WorkStatus = {
    WORKING: '在职',
    LEFT: '离职'
};


// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/constants.js